import React, { useCallback } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { FormattedMessage } from "react-intl";
import cx from "classnames"
import FormGroup from "react-bootstrap/FormGroup";
import withStyles from "isomorphic-style-loader/withStyles";
import messages from "../../../locale/messages";
import PlaceGeoSuggest from "../../Common/PlaceGeoSuggest/PlaceGeoSuggest";
import bt from '../../commonStyle.css';
import s from './LocationSearchForm.css';

function LocationSearchForm(props) {
    const { pricingType, intl: { formatMessage }, change } = props

    const handleSelectSuggest = useCallback(async (name, data, value) => {
        let location = {
            label: value,
            lat: data?.location?.latitude,
            lng: data?.location?.longitude,
        }
        await change(name, { location } || '')
    })
    const renderPlacesSuggest = useCallback(({ input, id, label, meta: { error }, initialValue, isTouched, disabled, placeholder }) => {
        return (
            <FormGroup className={'mb0'}>
                <label className={bt.commonLabelText}>{label}</label>
                <PlaceGeoSuggest
                    {...input}
                    label={label}
                    placeholder={placeholder}
                    handleSelectSuggest={(data, value) => handleSelectSuggest(input.name, data || '', value)}
                    disabled={disabled}
                    initialValue={initialValue}
                    id={id}
                    inputClass={cx(bt.formControlInput, 'form-control')}
                    containerClassName="categoryLocationSearchContainer"
                />
                {isTouched && error && <span>{formatMessage(error)}</span>}
            </FormGroup>
        )
    }, []);

    return (
        <>
            {
                (pricingType === 'hourly' || pricingType === 'fixed') && (
                    <div>
                        <div className={s.viewCategoryHourlySearchHeading}>
                            <FormattedMessage {...messages.chooseLocation} />
                        </div>
                        <Field
                            name="location"
                            type="text"
                            component={renderPlacesSuggest}
                            label={formatMessage(messages.yourLocationText)}
                            placeholder={formatMessage(messages.locationLabel)}
                            disabled={false}
                            autoComplete='off'
                            id={`geo_suggest_pickUp`}
                        />
                    </div>
                )
            }
        </>
    )

}
LocationSearchForm = reduxForm({
    form: 'LocationSearchForm',
})(LocationSearchForm);

const selector = formValueSelector("LocationSearchForm")
const mapState = (state) => ({
    pricingType: selector(state, 'pricingType') || '',
    location: selector(state, 'location')
})

export default injectIntl(withStyles(bt, s)(connect(mapState, {})(LocationSearchForm)))